export default function Text({ children, className = '' }) {
  return <div className={`${className} break-words`}>{children}</div>;
}
